/* 
 * ProblemLinkingFeedbackMediator.js
 * Using the problem model to create draggable solution and argument buttons that need to be matched
 * 
 * @author Olivier van der Pool for Ranj
 */

import AbstractMediator from "../../../core/ui/AbstractMediator";
import NavigateEvent from "../../../core/navigation/NavigateEvent";
import ProblemLinkingFeedbackHelper from "../controller/ProblemLinkingFeedbackHelper";

export default class ProblemLinkingFeedbackMediator extends AbstractMediator {
    constructor(target, dispatcher, soundManager, assetLibrary, scenarioLibrary) {
        super(target, dispatcher);
        this._soundManager = soundManager;
        this._assetLibrary = assetLibrary;

        this._problemModel = scenarioLibrary.getCurrentScenario().problemModel;
        this._playerModel = this._target.playerModel;
        this._problem = this._problemModel.getProblemByID("australia_kangaroos");
        //this._selectedSolution = null;
        //this._selectedArguments = [null, null, null, null]; 

        for (let i = 1; i <= 4; i++) {
            this._target[`argument${i}`].visible = false;
            this._target[`argument${i}_correct`].visible = false;
            this._target[`argument${i}_correct`].alpha = 0.4;
            this._target[`argument${i}_incorrect`].visible = false;
            this._target[`argument${i}_incorrect`].alpha = 0.4;
        }

        this._submitButton = this.createButton(this._target.submitButton, this._handleSubmitClick.bind(this));
    }

    initialize() {
        super.initialize();
        this._target.problemDescriptionField.text = this._problem.getDescription();

        const feedbackHelper = new ProblemLinkingFeedbackHelper();
        feedbackHelper.handleFeedback(this._playerModel, this._problemModel, this._onSolutionFeedback.bind(this), this._onArgumentFeedback.bind(this));
        /*
        var i, skin, dragButton;
        for(i = 0; i < this._selectedArguments; i++) {
            if(!isNull(this._selectedArguments[i])) {
                var argumentButton = this._target["argument"+i];
                var argument = this._problemModel.getPossibleArgumentByID(this._selectedArguments[i]);
                argumentButton.descriptionField.text = argument.getDescription();
                if(this._problemModel.isArgumentCorrect(this._problem.getID(), this._selectedSolution.getID(), argument.getID())) {
                    this._target["argument"+i+"_correct"].visible = true;
                } else {
                    this._target["argument"+i+"_incorrect"].visible = true;
                }
            }
        }*/
    }

    _onSolutionFeedback(result, playerSolution, correctSolution, problem) {
        const feedback = problem.getSolutionByID(playerSolution.getID()).getFeedbackDescription();
        const feedbacklabel = problem.getSolutionByID(playerSolution.getID()).getFeedbackLabel();
        this._target.solutionFeedbackField.text = feedback;
        this._target.solutionFeedbackLabelField.text = feedbacklabel;
        this._target.solutionButton.descriptionField.text = problem.getSolutionByID(playerSolution.getID()).getDescription();
    }

    _onArgumentFeedback(result, argument) {
        this._target[`argument${argument.buttonIndex}`].visible = true;
        this._target[`argument${argument.buttonIndex}`].descriptionField.text = argument.getDescription();
        if (result) this._target[`argument${argument.buttonIndex}_correct`].visible = true;
        else this._target[`argument${argument.buttonIndex}_incorrect`].visible = true;
    }

    _handleSubmitClick() {
        const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._target);
        this.dispatch(commandEvent.type, { data: commandEvent });
    }

    destroy() {
        super.destroy();
    }
}